const paths = {
  listSubdivision: '/subdivision/list',
  editSubdivision: '/subdivision/edit'
};

export default paths;
